import { createFileRoute } from '@tanstack/react-router'

import { useGetClientMarket, useGetItchConnection } from '@/gen/publicApi'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError'

import Content from '@/components/content'

import { useSetBreadcrumbs } from '@/state/breadcrumbs.tsx'

import MarketHeading from '../../-components/marketHeading'

import ItchConnectionDetails from './-components/itch_connection_details.tsx'

export const Route = createFileRoute('/_authed/$client_code/markets/$market_code/connections/itch/$connection_id/')({
    component: MarketConnectionsComponent,
})

function MarketConnectionsComponent() {
    const { client_code, market_code, connection_id } = Route.useParams()

    const market = useGetClientMarket(client_code, market_code, { query: { suspense: true } })
    const { data: connectionData } = useGetItchConnection(client_code, connection_id, { query: { suspense: true } })

    useSetBreadcrumbs([
        {
            to: '/$client_code/markets',
            text: 'Markets',
            params: {
                client_code,
            },
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code',
            params: {
                market_code,
                client_code,
            },
            text: market.data?.name || '--',
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code/connections',
            params: {
                market_code,
                client_code,
            },
            text: 'Connections',
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code/connections/itch/$connection_id',
            params: {
                market_code,
                client_code,
                connection_id,
            },
            text: `${connectionData?.username} (ITCH)`,
        },
    ])

    if (!market.data || !connectionData) {
        return <UnexpectedDataStateError />
    }

    return (
        <>
            <MarketHeading market={market.data} />
            <Content>
                <ItchConnectionDetails clientCode={client_code} connectionId={connection_id} />
            </Content>
        </>
    )
}
